/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';
import { RequestError } from 'src/utils/errorUtils';

const get = async (endpoint: string, params?: string, config: AxiosRequestConfig = {}) => {
  try {
    let requestUrl = endpoint;
    if (params) requestUrl += `?${params}`;

    const result = await axios.get(requestUrl, config);
    return result.data;
  } catch (error: any) {
    throw new RequestError(error.message, error.response?.status);
  }
};

const post = async (endpoint: string, data: unknown, config: AxiosRequestConfig = {}) => {
  try {
    const result = await axios.post(endpoint, data, config);
    return result.data;
  } catch (error: any) {
    throw new RequestError(error.message, error.response?.status);
  }
};

const put = async (endpoint: string, data: unknown, config: AxiosRequestConfig = {}) => {
  try {
    const result = await axios.put(endpoint, data, config);
    return result.data;
  } catch (error: any) {
    throw new RequestError(error.message, error.response?.status);
  }
};

const del = async (endpoint: string,  config: AxiosRequestConfig = {}) => {
  try {
    const result = await axios.delete(endpoint, config);
    return result.data;
  } catch (error: any) {
    throw new RequestError(error.message, error.response?.status);
  }
};

export {
  get,
  post,
  put,
  del,
};